<template>
  <el-card>
    <el-form>
      <el-form-item prop="formTime" :label="$t('orders.label.form.submitTime')">
        <range-date-picker ref="datePick" @showDateTime="handleShowDateTime" />
      </el-form-item>
      <el-form-item>
        <el-button size="mini" type="success" @click="handleEmpty">{{$t('btns.empty') }}</el-button>
        <el-button size="mini" type="primary" @click="getUserContactsList">{{$t('btns.search') }}</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tableList.list" :header-cell-style="{ 'text-align': 'center' }"
      :cell-style="{ textAlign: 'center' }" stripe>
      <el-table-column type="index" label="#"></el-table-column>
      <el-table-column prop="name" :label="$t('accountmanager.userName')" />
      <el-table-column prop="phone" :label="$t('accountmanager.userPhone')" />
      <el-table-column prop="email" label="Email" />
      <el-table-column prop="content" :label="$t('orders.label.form.remark')" />
      <el-table-column prop="createTime" :label="$t('withdraw.label.createTime')"></el-table-column>
    </el-table>

    <v-pagination v-model="form" :total="tableList.rows" @update="getUserContactsList" />
  </el-card>
</template>

<script>
  import logsApi from '@/api/logs';
  import RangeDatePicker from '../cuscom/range-date-picker.vue';

  export default {
    name: "channelConf",
    components: { RangeDatePicker },
    data() {
      return {
        formDate: [],
        form: {
          no: 1,
          size: this.$defaultPaginationSize,
          query: {
            beginDate: '',
            endDate: ''
          }
        },
        tableList: {}
      };
    },
    mounted() {
      this.getUserContactsList();
    },
    methods: {
      async getUserContactsList() {
        const { data } = await logsApi.getUserContacts(this.form);
        console.log(data)
        if (data.code === 200) {
          this.tableList = data.data ? data.data : [];
        } else {
          this.$message.error(data.msg || 'Error');
        }
      },
      handleEmpty() {
        this.$refs.datePick.handleTime();
      },
      handleShowDateTime(val) {
        [this.form.query.beginDate, this.form.query.endDate] = val
        this.getUserContactsList()
      }
    }
  };
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/components/apply/index.vue